import $ from "jquery";
import Track from "util/Track";
export default function handleInstagramFeed() {
    let $elements = $('.js-instagram-feed');

    if ($elements.length <= 0) {
        return;
    }

    Ajax.get('eotw', 'instagramFeed', {}).then((response) => {
        if(response.success) {
            $elements.html(response.data.html);

            new Track($elements, {
                classes: {
                    block: "slider",
                },
            });

            return;
        }

        console.warn('Could not load instagram feed', response);
    }).catch((e) => {
        console.warn('Could not load instagram feed', e);
    });
}
